export const SPECS = {
  AddIsPickupFlowToCheckoutUrl: 'specs.stores.AddIsPickupFlowToCheckoutUrl',
  UseSingleCustomerDetailsFormWithComposer: 'specs.stores.UseSingleCustomerDetailsFormWithComposer',
  ShouldForwardContactDetailsPickupFlow: 'specs.stores.ShouldForwardContactDetailsPickupFlow',
  ShouldPassSelectedShippingOptionToExpressCheckout: 'specs.stores.ShouldPassSelectedShippingOptionToExpressCheckout'
};
//# sourceMappingURL=SPECS.js.map